export const UploadIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 17 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.49935 11.332V7.33203L5.16602 8.66537"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 7.33203L7.83333 8.66537"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1673 6.66537V9.99871C15.1673 13.332 13.834 14.6654 10.5007 14.6654H6.50066C3.16732 14.6654 1.83398 13.332 1.83398 9.99871V5.9987C1.83398 2.66537 3.16732 1.33203 6.50066 1.33203H9.834"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1673 6.66537H12.5007C10.5007 6.66537 9.83398 5.99871 9.83398 3.9987V1.33203L15.1673 6.66537Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
